
















































































































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import Api from "@/api";
import FormErrorsMixin from "@/mixins/FormErrors";

import NavigationTabs from "@/components/Settings/Events/NavigationTabs.vue";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import TextInput from "@/components/Common/Inputs/TextInput.vue";
import InfoButton from "@/components/Common/Buttons/InfoButton.vue";
import BackButton from "@/components/Common/Buttons/BackButton.vue";
import DangerButton from "@/components/Common/Buttons/DangerButton.vue";
import Error404 from "@/components/Common/Error404.vue";
import swal from "sweetalert";
import { ICountry, ICountryState, IVenue } from "@/interface";
import { AxiosResponse } from "axios";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    NavigationTabs,
    TextInput,
    InfoButton,
    BackButton,
    DangerButton,
    Error404
  }
})
export default class EventVenue extends Mixins(FormErrorsMixin) {
  public loading = false;
  public updating = false;
  public validatedInputs = [
    "name",
    "country_id",
    "state_id",
    "city",
    "post_code",
    "street_name",
    "street_number",
    "additional_information"
  ];
  private noDataExist = false;
  private countries: Array<ICountry> = [];
  private states: Array<ICountryState> = [];
  private countryId: number | null = null;
  private stateId: number | null = null;
  private selectedVenue: IVenue = {
    name: null,
    description: null,
    address: {
      country_id: null,
      state_id: null,
      post_code: null,
      city: null,
      street_name: null,
      additional_information: null
    }
  };
  private selectedVenueId: string | null = null;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedVenueId = vm.$route.params.venue_id;
      // Get countries
      vm.getCountries(() => {
        //
      });

      // Get Venue
      if (
        typeof vm.selectedVenueId !== "undefined" &&
        vm.selectedVenueId !== null
      ) {
        if (vm.$route.query.venue_created === "true") {
          swal("Success!", "The venue was created.", "success").then(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          });
        }
        vm.getVenue(() => {
          //
        });
      }
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    // Get countries
    this.getCountries(() => {
      //
    });

    // Get Venue
    if (
      typeof this.selectedVenueId !== "undefined" &&
      this.selectedVenueId !== null
    ) {
      this.getVenue(() => {
        //
      });
    }
    next();
  }

  private createOrUpdateVenue(): void {
    if (this.selectedVenueId == null) {
      this.createVenue();
    } else {
      this.updateVenue();
    }
  }

  private getVenue(successCallback?: any): void {
    this.resetErrors();
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedVenue = response.data.data;
        if (!this.selectedVenue.address) {
          this.selectedVenue.address = {
            post_code: null,
            city: null,
            street_name: null,
            additional_information: null,
            state_id: null,
            country_id: null
          };
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private updateVenue(): void {
    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint(
      "venues/" + this.selectedVenueId
    );

    Api()
      .put(endpoint, this.selectedVenue)
      .then((response: AxiosResponse) => {
        this.selectedVenueId = response.data.data.id;
        this.getVenue();
      })
      .catch((error: any) => {
        console.log(error);
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private createVenue(): void {
    if (this.updating) {
      return;
    }

    this.resetErrors();
    this.updating = true;
    const endpoint: string = this.$partnerEndpoint("venues");

    Api()
      .post(endpoint, this.selectedVenue)
      .then((response: AxiosResponse) => {
        this.selectedVenueId = response.data.data.id;
        this.$router.push({
          name: "EventVenueDetails",
          params: {
            venue_id: `${this.selectedVenueId}`
          },
          query: { venue_created: "true" }
        });
      })
      .catch((error: any) => {
        this.storeErrors(error.response.data.errors);
      })
      .finally(() => {
        this.updating = false;
      });
  }

  private deleteVenue(): void {
    if (this.loading || this.updating) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The external venue will be deleted and will not be able to use it",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint: string = this.$partnerEndpoint(
          "venues/" + this.selectedVenueId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router.push({
              name: "EventVenues",
              query: { venue_deleted: "true" }
            });
          })
          .catch((error: any) => {
            console.log(error.response);
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete external venues.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private getCountries(successCallback: any): void {
    this.loading = true;

    Api()
      .get("api/internal/v1/countries")
      .then((response: AxiosResponse) => {
        this.countries = response.data.data;
        if (this.countryId === null && response.data.data.length) {
          this.countryId = response.data.data[0].id;
        }
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        console.log(error);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  @Watch("countryId")
  countryIdChanged(state: number): void {
    if (this.selectedVenue.address) {
      this.selectedVenue.address.country_id = state;
    }
    const states = this.countries.find(
      (country: ICountry) => country.id === state
    )?.states;
    if (states) {
      this.states = states;
    }
    if (
      states !== null &&
      states !== undefined &&
      states.length &&
      states[0].id
    ) {
      this.stateId = states[0].id;
    }
  }

  @Watch("stateId")
  stateIdChanged(state: number): void {
    if (this.selectedVenue.address) {
      this.selectedVenue.address.state_id = state;
    }
  }
}
